export default (elementId) => {
    if (elementId) {
        const target = document.getElementById(elementId)
        target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        })
    } else {
        const target = document.documentElement
        target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        })
    }
}



// WEBPACK FOOTER //
// ./src/scripts/utils/scrollTo.js